





































import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { IDialog } from '@/model'
import { mapGetters } from 'vuex'

@Component({
  computed: {
    ...mapGetters('palletpatterns', ['checkName'])
  }
})
export default class CopyPatternDialog extends Vue {
  @Prop () private value: boolean = false
  @Prop () private dialogProps!: IDialog
  @Prop ({required: true}) private selectedName!: string

  private rules: object = {
    required: (v: any) => !!v || this.localText ('general.required'),
    min: (v: any) => (v && v.length >= 3) || this.localText ('basicStep.minThree'),
    ascii: (v: any) => {
      // console.log('ascii-rule: ', v)
      const pattern = /^[0-9a-zA-Z]([a-zA-Z0-9_])+$/ // ascii
      return pattern.test (v) || this.localText ('general.invalidChars')
    }
  }
  private selectedPatternName: string = ''
  private checkName!: (name: string) => boolean
  private valid: boolean = false

  get show () {
    return this.value
  }

  set show (value) {
    this.$emit ('input', value)
  }

  private localText (b: string): string {
    return String (this.$t (b))
  }

  private checkIfNameExists (name: string): boolean | string {
    if (!name) {
      return this.localText('general.required')
    }
    const nameFound = this.checkName (name)
    if (nameFound) {
      return this.localText('general.nameAlreadyExists')
    }
    return true
  }

  private resolve: any = () => {
    return false
  }

  private accept () {
    this.$emit ('accept', this.selectedPatternName)
    this.resolve (true)
  }

  private cancel () {
    this.$emit ('cancel')
    this.resolve (true)
  }

  private onNameInput() {
    Vue.nextTick((this.$refs.form as any).validate)
  }

  @Watch('selectedName')
  private selectedPatternWatcher(selectedName: string) {
    // change name if selected pattern was changed
    this.selectedPatternName = selectedName + '_copy'
    this.onNameInput()
  }

}
